export const ACCOUNT_PATH = '/account';
export const CN_POS_INTEGRATIONS_PATH = '/pos-integrations';
export const SQUARE_POS_PATH = `${CN_POS_INTEGRATIONS_PATH}/square`;
export const TOAST_POS_PATH = `${CN_POS_INTEGRATIONS_PATH}/toast`;
export const CUBOH_INTEGRATIONS_PATH = '/integrations';
export const GET_STARTED_PATH = '/get-started';
export const GO_LIVE_CHECKLIST_PATH = '/progress';
export const HQ_DETAILS_PATH = '/company';
export const INTERNAL_PATH = '/admin';
export const LOCATION_PATH = '/restaurant';
export const USERS_PATH = '/users';
export const ORDERS_PATH = '/orders';
export const HOME_PATH = '/';
export const MENU_PATH = '/menu';
export const ONBOARDING_PATH = '/onboarding';
export const ORDERS_CONTROL_PATH = '/orders-control';
export const POS_MENU_SETTINGS_PATH = '/pos-menu-settings';
export const OVERVIEW_PATH = '/overview';
export const LOCATION_HOME_PATH = 'home';
export const CHANNEL_INSIGHTS_PATH = 'channel-insights';
export const PBB_PATH = '/preferredpartner';
export const POS_MENU_SETTINGS_ROUTE = `${LOCATION_PATH}/:restaurantId${POS_MENU_SETTINGS_PATH}/*`;
export const ONBOARDING_ROUTE = `${LOCATION_PATH}/:restaurantId${ONBOARDING_PATH}`;

export const ALL_RESTAURANTS = `${INTERNAL_PATH}/restaurants`;
export const ALL_HQS = `${INTERNAL_PATH}/companies`;

export const ACCOUNT_INVOICE_PATH = `${ACCOUNT_PATH}/invoice`;
export const ACCOUNT_SETTINGS_PATH = `${ACCOUNT_PATH}/settings`;
export const CUSTOMIZATIONS_PATH = 'customizations';
export const EMAIL_NOTIFICATIONS_PATH = 'email-notifications';
export const THIRD_PARTY_ORDERS_PATH = '3rd-party-orders';
export const TRANSACTION_FEES_PATH = 'transaction-fees';
export const WEBSITE_ACCESS_PATH = 'website-access';
// Have to make reports path relative since we're now sometimes nesting under locations
export const REPORTS_PATH = 'reports';
export const ANALYTICS_PATH = `${REPORTS_PATH}/analytics`;

export const CUBOH_COMPANY_PREFIX = 'cuboh-';

export const QUERY_PARAMS = {
  restaurantId: 'restaurantId', // for cube filtering (for now), expects an array ['2', '16']
  hqId: 'hqId', // for all dashboard views, internal users only
  time: 'time', // for cube filtering (for now), expects a string
} as const;

// if a user selects a new location while on one of these or any of their subpaths
// redirect to here - not the sub path
export const LOCATION_PATHS_TO_CUT_OFF_ON_LOCATION_SELECT: string[] = [
  CN_POS_INTEGRATIONS_PATH,
  MENU_PATH,
  ORDERS_PATH,
  POS_MENU_SETTINGS_PATH,
];

// cut off paths that land somewhere other than themselves. The CN POS list is no longer in the
// nav, so its pages fall back to the merged Integrations page
export const LOCATION_CUT_OFF_DESTINATIONS: Record<string, string> = {
  [CN_POS_INTEGRATIONS_PATH]: CUBOH_INTEGRATIONS_PATH,
};

export const LOCATION_PATHS_TO_EXCLUDE_FROM_CUT_OFFS: string[] = [
  THIRD_PARTY_ORDERS_PATH,
  ORDERS_CONTROL_PATH,
];
